"use client";

import { useStepsStore, type StepsState } from "@/stores";

export type { StepsState };

const useSteps = (): StepsState => useStepsStore();

export { useSteps };
